import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "../utils/axiosInstance";
import CategoryPage from "../pages/CategoryPage";

const CategoryPageWrapper = () => {
  const { categoryId } = useParams();
  const [categoryName, setCategoryName] = useState("");
  const [products, setProducts] = useState([]);
  const [brand, setBrand] = useState([]);
 const [categories, setCategories] = useState([]);
   const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // useDynamicTabTitle(categoryName ? `Buy ${categoryName}?` : "Loading...");
const fetchData = async () => {
    try {
      setLoading(true);
      const [productRes, categoriesRes,brandRes,categoryRes] = await Promise.all([
        axios.get(`/products/category/${categoryId}`),
        axios.get(`/categories/${categoryId}/subcategories`),
         axios.get(`/brands`),
          axios.get(`/categories/${categoryId}`),
      ]);
      // console.log("category=", categoryRes.data.leafCategories);
      setProducts(productRes.data);
      setCategories(categoriesRes.data.subCategories);
      setBrand(brandRes.data.data);
      setCategoryName(categoryRes.data.data.name);
      // console.log("category=",categoryRes.data.data.name);
    } catch (err) {
      console.error("❌ Error loading data:", err);
      setError("Error Loading data!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [categoryId]);

  return (
    <CategoryPage
      categoryName={categoryName}
      products={products}
      categoryId={categoryId}
      categories={categories}
      brand={brand}
    />
  );
};

export default CategoryPageWrapper;

  // useEffect(() => {
  //   axios.get(`/products/category/${categoryId}`)
  //     .then(res => setProducts(res.data))
  //     .catch(err => console.error(err));
  // }, [categoryId]);

  //   axios
  //     .get(`/categories/${categoryId}`)
  //     .then((res) => {
  //       if (res.data.status && res.data.data) {
  //         const name = res.data.data.name;
  //         setCategoryName(name);

  //         // مرحله 2: گرفتن محصولات با اسم دسته
  //         axios
  //           .get(`/products?category=${encodeURIComponent(name)}`)
  //           .then((res) => {
  //             if (res.data.status) {
  //               setProducts(res.data.products);
  //             }
  //           })
  //           .catch((err) => {
  //             console.error("Error fetching products:", err);
  //           });
  //       }
  //     })
  //     .catch((err) => {
  //       console.error("Error fetching category:", err);
  //     });
  // }, [categoryId]);
